/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPilcrow = createReactComponent("outline", "pilcrow", "IconPilcrow", [["path", { "d": "M13 4v16", "key": "svg-0" }], ["path", { "d": "M17 4v16", "key": "svg-1" }], ["path", { "d": "M19 4h-9.5a4.5 4.5 0 0 0 0 9h3.5", "key": "svg-2" }]]);

export { IconPilcrow as default };
//# sourceMappingURL=IconPilcrow.mjs.map
